export const cities = [
    // { value:"Select City", label:"Select City"},
    { value:"Bhimbar", label:"Bhimbar"},
    { value:"Kotli", label:"Kotli"},
    { value:"Kotli District", label:"Kotli District"},
    { value:"Mirpur District", label:"Mirpur District"},
    { value:"Muzaffarābād", label:"Muzaffarābād"},
    { value:"New Mirpur", label:"New Mirpur"},
    { value:"Rawala Kot", label:"Rawala Kot"},


    { value:"Alik Ghund", label:"Alik Ghund"},
    { value:"Awārān District", label:"Awārān District"},
    { value:"Barkhan", label:"Barkhan"},
    { value:"Bārkhān District", label:"Bārkhān District"},
    { value:"Bela", label:"Bela"},
    { value:"Bhag", label:"Bhag"},
    { value:"Chāgai District", label:"Chāgai District"},
    { value:"Chaman", label:"Chaman"},
    { value:"Chowki Jamali", label:"Chowki Jamali"},
    { value:"Dadhar", label:"Dadhar"},
    { value:"Dalbandin", label:"Dalbandin"},
    { value:"Dera Bugti", label:"Dera Bugti"},
    { value:"Dera Bugti District", label:"Dera Bugti District"},
    { value:"Duki", label:"Duki"},
    { value:"Gadani", label:"Gadani"},
    { value:"Garhi Khairo", label:"Garhi Khairo"},
    { value:"Gwadar", label:"Gwadar"},
    { value:"Harnai", label:"Harnai"},
    { value:"Jāfarābād District", label:"Jāfarābād District"},
    { value:"Jhal Magsi District", label:"Jhal Magsi District"},
    { value:"Jiwani", label:"Jiwani"},
    { value:"Kalat", label:"Kalat"},
    { value:"Kalāt District", label:"Kalāt District"},
    { value:"Khadan Khak", label:"Khadan Khak"},
    { value:"Kharan", label:"Kharan"},
    { value:"Khārān District", label:"Khārān District"},
    { value:"Khuzdar", label:"Khuzdar"},
    { value:"Khuzdār District", label:"Khuzdār District"},
    { value:"Kohlu", label:"Kohlu"},
    { value:"Kot Malik Barkhurdar", label:"Kot Malik Barkhurdar"},
    { value:"Lasbela District", label:"Lasbela District"},
    { value:"Loralai", label:"Loralai"},
    { value:"Loralai District", label:"Loralai District"},
    { value:"Mach", label:"Mach"},
    { value:"Mastung", label:"Mastung"},
    { value:"Mastung District", label:"Mastung District"},
    { value:"Mehrabpur", label:"Mehrabpur"},
    { value:"Mūsa Khel District", label:"Mūsa Khel District"},
    { value:"Nasīrābād District", label:"Nasīrābād District"},
    { value:"Nushki", label:"Nushki"},
    { value:"Ormara", label:"Ormara"},
    { value:"Panjgūr District", label:"Panjgūr District"},
    { value:"Pasni", label:"Pasni"},
    { value:"Pishin", label:"Pishin"},
    { value:"Qila Saifullāh District", label:"Qila Saifullāh District"},
    { value:"Quetta", label:"Quetta"},
    { value:"Quetta District", label:"Quetta District"},
    { value:"Sibi", label:"Sibi"},
    { value:"Sohbatpur", label:"Sohbatpur"},
    { value:"Surab", label:"Surab"},
    { value:"Turbat", label:"Turbat"},
    { value:"Usta Muhammad", label:"Usta Muhammad"},
    { value:"Uthal", label:"Uthal"},
    { value:"Zhob", label:"Zhob"},
    { value:"Zhob District", label:"Zhob District"},
    { value:"Ziarat", label:"Ziarat"},
    { value:"Ziārat District", label:"Ziārat District"},


    { value:"Alizai", label:"Alizai"},
    { value:"Gulishah Kach", label:"Gulishah Kach"},
    { value:"Landi Kotal", label:"Landi Kotal"},
    { value:"Miran Shah", label:"Miran Shah"},
    { value:"North Wazīristān Agency", label:"North Wazīristān Agency"},
    { value:"Shinpokh", label:"Shinpokh"},
    { value:"South Wazīristān Agency", label:"South Wazīristān Agency"},
    { value:"Wana", label:"Wana"},

    { value:"Barishal", label:"Barishal"},
    { value:"Gilgit", label:"Gilgit"},
    { value:"Skardu", label:"Skardu"},

    { value:"Islamabad", label:"Islamabad"},


    { value:"Abbottabad", label:"Abbottabad"},
    { value:"Akora", label:"Akora"},
    { value:"Aman Garh", label:"Aman Garh"},
    { value:"Amirabad", label:"Amirabad"},
    { value:"Ashanagro Koto", label:"Ashanagro Koto"},
    { value:"Baffa", label:"Baffa"},
    { value:"Bannu", label:"Bannu"},
    { value:"Bat Khela", label:"Bat Khela"},
    { value:"Battagram", label:"Battagram"},
    { value:"Battagram District", label:"Battagram District"},
    { value:"Buner District", label:"Buner District"},
    { value:"Charsadda", label:"Charsadda"},
    { value:"Cherat Cantonement", label:"Cherat Cantonement"},
    { value:"Chitral", label:"Chitral"},
    { value:"Dera Ismail Khan", label:"Dera Ismail Khan"},
    { value:"Dera Ismāīl Khān District", label:"Dera Ismāīl Khān District"},
    { value:"Doaba", label:"Doaba"},
    { value:"Hangu", label:"Hangu"},
    { value:"Haripur", label:"Haripur"},
    { value:"Havelian", label:"Havelian"},
    { value:"Kakad Wari Dir Upper", label:"Kakad Wari Dir Upper"},
    { value:"Karak", label:"Karak"},
    { value:"Khalabat", label:"Khalabat"},
    { value:"Kohat", label:"Kohat"},
    { value:"Kulachi", label:"Kulachi"},
    { value:"Lachi", label:"Lachi"},
    { value:"Lakki", label:"Lakki"},
    { value:"Mansehra", label:"Mansehra"},
    { value:"Mardan", label:"Mardan"},
    { value:"Mingora", label:"Mingora"},
    { value:"Noorabad", label:"Noorabad"},
    { value:"Nowshera", label:"Nowshera"},
    { value:"Nowshera Cantonment", label:"Nowshera Cantonment"},
    { value:"Pabbi", label:"Pabbi"},
    { value:"Paharpur", label:"Paharpur"},
    { value:"Peshawar", label:"Peshawar"},
    { value:"Risalpur Cantonment", label:"Risalpur Cantonment"},
    { value:"Sarai Naurang", label:"Sarai Naurang"},
    { value:"Shabqadar", label:"Shabqadar"},
    { value:"Shingli Bala", label:"Shingli Bala"},
    { value:"Shorkot", label:"Shorkot"},
    { value:"Swabi", label:"Swabi"},
    { value:"Tangi", label:"Tangi"},
    { value:"Tank", label:"Tank"},
    { value:"Thal", label:"Thal"},
    { value:"Topi", label:"Topi"},
    { value:"Upper Dir", label:"Upper Dir"},
    { value:"Utmanzai", label:"Utmanzai"},
    { value:"Zaida", label:"Zaida"},

    { value:"Ahmadpur Sial", label:"Ahmadpur Sial"},
    { value:"Ahmedpur East", label:"Ahmedpur East"},
    { value:"Alipur Chatha", label:"Alipur Chatha"},
    { value:"Arifwala", label:"Arifwala"},
    { value:"Attock Tehsil", label:"Attock Tehsil"},
    { value:"Baddomalhi", label:"Baddomalhi"},
    { value:"Bahawalnagar", label:"Bahawalnagar"},
    { value:"Bahawalpur", label:"Bahawalpur"},
    { value:"Bakhri Ahmad Khan", label:"Bakhri Ahmad Khan"},
    { value:"Basirpur", label:"Basirpur"},
    { value:"Basti Dosa", label:"Basti Dosa"},
    { value:"Begowala", label:"Begowala"},
    { value:"Bhakkar", label:"Bhakkar"},
    { value:"Bhalwal", label:"Bhalwal"},
    { value:"Bhawana", label:"Bhawana"},
    { value:"Bhera", label:"Bhera"},
    { value:"Bhopalwala", label:"Bhopalwala"},
    { value:"Burewala", label:"Burewala"},
    { value:"Chak Azam Saffo", label:"Chak Azam Saffo"},
    { value:"Chak Jhumra", label:"Chak Jhumra"},
    { value:"Chak One Hundred Twenty Nine Left", label:"Chak One Hundred Twenty Nine Left"},
    { value:"Chak Thirty-one -Eleven Left", label:"Chak Thirty-one -Eleven Left"},
    { value:"Chak Two Hundred Forty-Nine TDA", label:"Chak Two Hundred Forty-Nine TDA"},
    { value:"Chakwal", label:"Chakwal"},
    { value:"Chawinda", label:"Chawinda"},
    { value:"Chichawatni", label:"Chichawatni"},
    { value:"Chiniot", label:"Chiniot"},
    { value:"Chishtian", label:"Chishtian"},
    { value:"Choa Saidanshah", label:"Choa Saidanshah"},
    { value:"Chuhar Kana", label:"Chuhar Kana"},
    { value:"Chunian", label:"Chunian"},
    { value:"Daira Din Panah", label:"Daira Din Panah"},
    { value:"Dajal", label:"Dajal"},
    { value:"Dandot RS", label:"Dandot RS"},
    { value:"Darya Khan", label:"Darya Khan"},
    { value:"Daska", label:"Daska"},
    { value:"Daud Khel", label:"Daud Khel"},
    { value:"Daultala", label:"Daultala"},
    { value:"Dera Ghazi Khan", label:"Dera Ghazi Khan"},
    { value:"Dhanot", label:"Dhanot"},
    { value:"Dhaunkal", label:"Dhaunkal"},
    { value:"Dhok Awan", label:"Dhok Awan"},
    { value:"Dijkot", label:"Dijkot"},
    { value:"Dinan Bashnoian Wala", label:"Dinan Bashnoian Wala"},
    { value:"Dinga", label:"Dinga"},
    { value:"Dipalpur", label:"Dipalpur"},
    { value:"Dullewala", label:"Dullewala"},
    { value:"Dunga Bunga", label:"Dunga Bunga"},
    { value:"Dunyapur", label:"Dunyapur"},
    { value:"Eminabad", label:"Eminabad"},
    { value:"Faisalabad", label:"Faisalabad"},
    { value:"Faqirwali", label:"Faqirwali"},
    { value:"Faruka", label:"Faruka"},
    { value:"Fazilpur", label:"Fazilpur"},
    { value:"Ferozewala", label:"Ferozewala"},
    { value:"Fort Abbas", label:"Fort Abbas"},
    { value:"Garh Maharaja", label:"Garh Maharaja"},
    { value:"Gojra", label:"Gojra"},
    { value:"Gujar Khan", label:"Gujar Khan"},
    { value:"Gujranwala", label:"Gujranwala"},
    { value:"Gujranwala Division", label:"Gujranwala Division"},
    { value:"Gujrat", label:"Gujrat"},
    { value:"Hadali", label:"Hadali"},
    { value:"Hafizabad", label:"Hafizabad"},
    { value:"Harnoli", label:"Harnoli"},
    { value:"Harunabad", label:"Harunabad"},
    { value:"Hasan Abdal", label:"Hasan Abdal"},
    { value:"Hasilpur", label:"Hasilpur"},
    { value:"Haveli Lakha", label:"Haveli Lakha"},
    { value:"Hazro", label:"Hazro"},
    { value:"Hujra Shah Muqeem", label:"Hujra Shah Muqeem"},
    { value:"Jahanian Shah", label:"Jahanian Shah"},
    { value:"Jalalpur Jattan", label:"Jalalpur Jattan"},
    { value:"Jalalpur Pirwala", label:"Jalalpur Pirwala"},
    { value:"Jampur", label:"Jampur"},
    { value:"Jand", label:"Jand"},
    { value:"Jandiala Sher Khan", label:"Jandiala Sher Khan"},
    { value:"Jaranwala", label:"Jaranwala"},
    { value:"Jatoi Shimali", label:"Jatoi Shimali"},
    { value:"Jauharabad", label:"Jauharabad"},
    { value:"Jhang", label:"Jhang"},
    { value:"Jhang Sadar", label:"Jhang Sadar"},
    { value:"Jhawarian", label:"Jhawarian"},
    { value:"Jhelum", label:"Jhelum"},
    { value:"Kabirwala", label:"Kabirwala"},
    { value:"Kahna Nau", label:"Kahna Nau"},
    { value:"Kahuta", label:"Kahuta"},
    { value:"Kalabagh", label:"Kalabagh"},
    { value:"Kalaswala", label:"Kalaswala"},
    { value:"Kaleke Mandi", label:"Kaleke Mandi"},
    { value:"Kallar Kahar", label:"Kallar Kahar"},
    { value:"Kalur Kot", label:"Kalur Kot"},
    { value:"Kamalia", label:"Kamalia"},
    { value:"Kamar Mushani", label:"Kamar Mushani"},
    { value:"Kamoke", label:"Kamoke"},
    { value:"Kamra", label:"Kamra"},
    { value:"Kanganpur", label:"Kanganpur"},
    { value:"Karor", label:"Karor"},
    { value:"Kasur", label:"Kasur"},
    { value:"Keshupur", label:"Keshupur"},
    { value:"Khairpur Tamiwali", label:"Khairpur Tamiwali"},
    { value:"Khandowa", label:"Khandowa"},
    { value:"Khanewal", label:"Khanewal"},
    { value:"Khanga Dogran", label:"Khanga Dogran"},
    { value:"Khangarh", label:"Khangarh"},
    { value:"Khanpur", label:"Khanpur"},
    { value:"Kharian", label:"Kharian"},
    { value:"Khewra", label:"Khewra"},
    { value:"Khurrianwala", label:"Khurrianwala"},
    { value:"Khushab", label:"Khushab"},
    { value:"Kohror Pakka", label:"Kohror Pakka"},
    { value:"Kot Addu Tehsil", label:"Kot Addu Tehsil"},
    { value:"Kot Ghulam Muhammad", label:"Kot Ghulam Muhammad"},
    { value:"Kot Mumin", label:"Kot Mumin"},
    { value:"Kot Radha Kishan", label:"Kot Radha Kishan"},
    { value:"Kot Rajkour", label:"Kot Rajkour"},
    { value:"Kot Samaba", label:"Kot Samaba"},
    { value:"Kot Sultan", label:"Kot Sultan"},
    { value:"Kotli Loharan", label:"Kotli Loharan"},
    { value:"Kundian", label:"Kundian"},
    { value:"Kunjah", label:"Kunjah"},
    { value:"Ladhewala Waraich", label:"Ladhewala Waraich"},
    { value:"Lahore", label:"Lahore"},
    { value:"Lala Musa", label:"Lala Musa"},
    { value:"Lalian", label:"Lalian"},
    { value:"Layyah", label:"Layyah"},
    { value:"Layyah District", label:"Layyah District"},
    { value:"Liliani", label:"Liliani"},
    { value:"Lodhran", label:"Lodhran"},
    { value:"Mailsi", label:"Mailsi"},
    { value:"Malakwal", label:"Malakwal"},
    { value:"Malakwal City", label:"Malakwal City"},
    { value:"Mamu Kanjan", label:"Mamu Kanjan"},
    { value:"Mananwala", label:"Mananwala"},
    { value:"Mandi Bahauddin", label:"Mandi Bahauddin"},
    { value:"Mandi Bahauddin District", label:"Mandi Bahauddin District"},
    { value:"Mangla", label:"Mangla"},
    { value:"Mankera", label:"Mankera"},
    { value:"Mehmand Chak", label:"Mehmand Chak"},
    { value:"Mian Channun", label:"Mian Channun"},
    { value:"Mianke Mor", label:"Mianke Mor"},
    { value:"Mianwali", label:"Mianwali"},
    { value:"Minchinabad", label:"Minchinabad"},
    { value:"Mitha Tiwana", label:"Mitha Tiwana"},
    { value:"Moza Shahwala", label:"Moza Shahwala"},
    { value:"Multan", label:"Multan"},
    { value:"Multan District", label:"Multan District"},
    { value:"Muridke", label:"Muridke"},
    { value:"Murree", label:"Murree"},
    { value:"Mustafabad", label:"Mustafabad"},
    { value:"Muzaffargarh", label:"Muzaffargarh"},
    { value:"Nankana Sahib", label:"Nankana Sahib"},
    { value:"Narang Mandi", label:"Narang Mandi"},
    { value:"Narowal", label:"Narowal"},
    { value:"Naushahra Virkan", label:"Naushahra Virkan"},
    { value:"Nazir Town", label:"Nazir Town"},
    { value:"Okara", label:"Okara"},
    { value:"Pakki Shagwanwali", label:"Pakki Shagwanwali"},
    { value:"Pakpattan", label:"Pakpattan"},
    { value:"Pasrur", label:"Pasrur"},
    { value:"Pattoki", label:"Pattoki"},
    { value:"Phalia", label:"Phalia"},
    { value:"Pind Dadan Khan", label:"Pind Dadan Khan"},
    { value:"Pindi Bhattian", label:"Pindi Bhattian"},
    { value:"Pindi Gheb", label:"Pindi Gheb"},
    { value:"Pir Mahal", label:"Pir Mahal"},
    { value:"Qadirpur Ran", label:"Qadirpur Ran"},
    { value:"Qila Didar Singh", label:"Qila Didar Singh"},
    { value:"Rabwah", label:"Rabwah"},
    { value:"Rahim Yar Khan", label:"Rahim Yar Khan"},
    { value:"Rahimyar Khan District", label:"Rahimyar Khan District"},
    { value:"Raiwind", label:"Raiwind"},
    { value:"Raja Jang", label:"Raja Jang"},
    { value:"Rajanpur", label:"Rajanpur"},
    { value:"Rasulnagar", label:"Rasulnagar"},
    { value:"Rawalpindi", label:"Rawalpindi"},
    { value:"Rawalpindi District", label:"Rawalpindi District"},
    { value:"Renala Khurd", label:"Renala Khurd"},
    { value:"Rojhan", label:"Rojhan"},
    { value:"Sadiqabad", label:"Sadiqabad"},
    { value:"Sahiwal", label:"Sahiwal"},
    { value:"Sambrial", label:"Sambrial"},
    { value:"Sangla Hill", label:"Sangla Hill"},
    { value:"Sanjwal", label:"Sanjwal"},
    { value:"Sarai Alamgir", label:"Sarai Alamgir"},
    { value:"Sarai Sidhu", label:"Sarai Sidhu"},
    { value:"Sargodha", label:"Sargodha"},
    { value:"Shahkot Tehsil", label:"Shahkot Tehsil"},
    { value:"Shahpur", label:"Shahpur"},
    { value:"Shahr Sultan", label:"Shahr Sultan"},
    { value:"Shakargarh", label:"Shakargarh"},
    { value:"Sharqpur", label:"Sharqpur"},
    { value:"Sheikhupura", label:"Sheikhupura"},
    { value:"Shorkot", label:"Shorkot"},
    { value:"Shujaabad", label:"Shujaabad"},
    { value:"Sialkot", label:"Sialkot"},
    { value:"Sillanwali", label:"Sillanwali"},
    { value:"Sodhra", label:"Sodhra"},
    { value:"Sukheke Mandi", label:"Sukheke Mandi"},
    { value:"Surkhpur", label:"Surkhpur"},
    { value:"Talagang", label:"Talagang"},
    { value:"Talamba", label:"Talamba"},
    { value:"Tandlianwala", label:"Tandlianwala"},
    { value:"Taunsa", label:"Taunsa"},
    { value:"Toba Tek Singh", label:"Toba Tek Singh"},
    { value:"Umerkot", label:"Umerkot"},
    { value:"Vihari", label:"Vihari"},
    { value:"Wah", label:"Wah"},
    { value:"Warburton", label:"Warburton"},
    { value:"Wazirabad", label:"Wazirabad"},
    { value:"West Punjab", label:"West Punjab"},
    { value:"Yazman", label:"Yazman"},
    { value:"Zafarwal", label:"Zafarwal"},
    { value:"Zahir Pir", label:"Zahir Pir"},

    { value:"Adilpur", label:"Adilpur"},
    { value:"Badin", label:"Badin"},
    { value:"Bagarji", label:"Bagarji"},
    { value:"Bandhi", label:"Bandhi"},
    { value:"Berani", label:"Berani"},
    { value:"Bhan", label:"Bhan"},
    { value:"Bhiria", label:"Bhiria"},
    { value:"Bhit Shah", label:"Bhit Shah"},
    { value:"Bozdar Wada", label:"Bozdar Wada"},
    { value:"Bulri", label:"Bulri"},
    { value:"Chak", label:"Chak"},
    { value:"Chamber", label:"Chamber"},
    { value:"Chhor", label:"Chhor"},
    { value:"Chuhar Jamali", label:"Chuhar Jamali"},
    { value:"Dadu", label:"Dadu"},
    { value:"Daromehar", label:"Daromehar"},
    { value:"Darya Khan Marri", label:"Darya Khan Marri"},
    { value:"Daulatpur", label:"Daulatpur"},
    { value:"Daur", label:"Daur"},
    { value:"Dhoro Naro", label:"Dhoro Naro"},
    { value:"Digri", label:"Digri"},
    { value:"Diplo", label:"Diplo"},
    { value:"Dokri", label:"Dokri"},
    { value:"Gambat", label:"Gambat"},
    { value:"Garhiyasin", label:"Garhiyasin"},
    { value:"Gharo", label:"Gharo"},
    { value:"Ghauspur", label:"Ghauspur"},
    { value:"Ghotki", label:"Ghotki"},
    { value:"Goth Garelo", label:"Goth Garelo"},
    { value:"Goth Phulji", label:"Goth Phulji"},
    { value:"Goth Radhan", label:"Goth Radhan"},
    { value:"Hala", label:"Hala"},
    { value:"Hingorja", label:"Hingorja"},
    { value:"Hyderabad", label:"Hyderabad"},
    { value:"Islamkot", label:"Islamkot"},
    { value:"Jacobabad", label:"Jacobabad"},
    { value:"Jām Sāhib", label:"Jām Sāhib"},
    { value:"Jamshoro", label:"Jamshoro"},
    { value:"Jati", label:"Jati"},
    { value:"Jhol", label:"Jhol"},
    { value:"Johi", label:"Johi"},
    { value:"Kadhan", label:"Kadhan"},
    { value:"Kambar", label:"Kambar"},
    { value:"Kandhkot", label:"Kandhkot"},
    { value:"Kandiari", label:"Kandiari"},
    { value:"Kandiaro", label:"Kandiaro"},
    { value:"Karachi", label:"Karachi"},
    { value:"Karaundi", label:"Karaundi"},
    { value:"Kario Ghanwar", label:"Kario Ghanwar"},
    { value:"Kashmor", label:"Kashmor"},
    { value:"Keti Bandar", label:"Keti Bandar"},
    { value:"Khadro", label:"Khadro"},
    { value:"Khairpur", label:"Khairpur"},
    { value:"Khairpur Mir’s", label:"Khairpur Mir’s"},
    { value:"Khairpur Nathan Shah", label:"Khairpur Nathan Shah"},
    { value:"Khanpur Mahar", label:"Khanpur Mahar"},
    { value:"Kot Diji", label:"Kot Diji"},
    { value:"Kotri", label:"Kotri"},
    { value:"Kunri", label:"Kunri"},
    { value:"Lakhi", label:"Lakhi"},
    { value:"Larkana", label:"Larkana"},
    { value:"Madeji", label:"Madeji"},
    { value:"Malir Cantonment", label:"Malir Cantonment"},
    { value:"Matiari", label:"Matiari"},
    { value:"Matli", label:"Matli"},
    { value:"Mehar", label:"Mehar"},
    { value:"Miro Khan", label:"Miro Khan"},
    { value:"Mirpur Bhtoro", label:"Mirpur Bhtoro"},
    { value:"Mirpur Khas", label:"Mirpur Khas"},
    { value:"Mirpur Mathelo", label:"Mirpur Mathelo"},
    { value:"Mirpur Sakro", label:"Mirpur Sakro"},
    { value:"Mirwah Gorchani", label:"Mirwah Gorchani"},
    { value:"Mithi", label:"Mithi"},
    { value:"Moro", label:"Moro"},
    { value:"Nabisar", label:"Nabisar"},
    { value:"Nasirabad", label:"Nasirabad"},
    { value:"Naudero", label:"Naudero"},
    { value:"Naukot", label:"Naukot"},
    { value:"Naushahro Firoz", label:"Naushahro Firoz"},
    { value:"Nawabshah", label:"Nawabshah"},
    { value:"New Bādāh", label:"New Bādāh"},
    { value:"Pad Idan", label:"Pad Idan"},
    { value:"Pano Aqil", label:"Pano Aqil"},
    { value:"Pir Jo Goth", label:"Pir Jo Goth"},
    { value:"Pithoro", label:"Pithoro"},
    { value:"Rajo Khanani", label:"Rajo Khanani"},
    { value:"Ranipur", label:"Ranipur"},
    { value:"Ratodero", label:"Ratodero"},
    { value:"Rohri", label:"Rohri"},
    { value:"Rustam", label:"Rustam"},
    { value:"Sakrand", label:"Sakrand"},
    { value:"Samaro", label:"Samaro"},
    { value:"Sanghar", label:"Sanghar"},
    { value:"Sann", label:"Sann"},
    { value:"Sehwan", label:"Sehwan"},
    { value:"Setharja Old", label:"Setharja Old"},
    { value:"Shahdad Kot", label:"Shahdad Kot"},
    { value:"Shahdadpur", label:"Shahdadpur"},
    { value:"Shahpur Chakar", label:"Shahpur Chakar"},
    { value:"Shikarpur", label:"Shikarpur"},
    { value:"Sinjhoro", label:"Sinjhoro"},
    { value:"Sīta Road", label:"Sīta Road"},
    { value:"Sobhodero", label:"Sobhodero"},
    { value:"Sukkur", label:"Sukkur"},
    { value:"Talhar", label:"Talhar"},
    { value:"Tando Adam", label:"Tando Adam"},
    { value:"Tando Allahyar", label:"Tando Allahyar"},
    { value:"Tando Bago", label:"Tando Bago"},
    { value:"Tando Jam", label:"Tando Jam"},
    { value:"Tando Mitha Khan", label:"Tando Mitha Khan"},
    { value:"Tando Muhammad Khan", label:"Tando Muhammad Khan"},
    { value:"Tangwani", label:"Tangwani"},
    { value:"Tharu Shah", label:"Tharu Shah"},
    { value:"Thatta", label:"Thatta"},
    { value:"Thul", label:"Thul"},
    { value:"Ubauro", label:"Ubauro"},
    { value:"Umarkot", label:"Umarkot"},
    { value:"Umerkot District", label:"Umerkot District"},
    { value:"Warah", label:"Warah"},
    { value:"Warah", label:"other"},

]

